module.exports = __webpack_public_path__ + "recognized-marker.f1b87a57cc3163a242118533afcaa751.svg";